import { DashboardModule, Form } from '@domain-group/suit-theme'

import useCampaignStatuses from '@hooks/useCampaignStatuses'

import { UseFormPayload } from '@domain-group/react-hooks'

type HandleSoldStatusParams = {
  campaign_status_id: string,
  campaignStatuses: {},
  setEntityState: UseFormPayload['setEntityState'],
  sold: boolean,
}

const handleSoldStatus = (params: HandleSoldStatusParams) => {
  const {
    campaignStatuses, setEntityState, sold, campaign_status_id,
  } = params

  setEntityState({ campaign_status_id: Number(campaign_status_id) })

  // @ts-expect-error TS7053
  const campaignStatus = campaignStatuses[campaign_status_id] || {}

  if (campaignStatus.title === 'Sold' && !sold){
    setEntityState({ sold: true })
  }

  if (campaignStatus.id && campaignStatus.title !== 'Sold' && sold){
    setEntityState({ sold: false })
  }
}

type CampaignStatusProps = {
  campaignForm: UseFormPayload,
}

const CampaignStatus = (props: CampaignStatusProps) => {
  const { campaignForm } = props

  const {
    entityState: {
      campaign_status_id,
      end_date,
      hide_sold_price,
      sold,
      sold_price,
      sold_date,
      start_date,
      under_offer,
    },
    handlers,
    setEntityState,
  } = campaignForm

  const {
    campaignStatuses,
    filteredCampaignStatuses,
  } = useCampaignStatuses({ performHttpRequests: true })

  return (
    <DashboardModule boxProps={{ marginBottom: 'large' }} title="Campaign Status">
      <Form padding="large">
        <Form.Row>
          <Form.Row>
            <Form.Field label="Campaign Status">
              <select
                onChange={e => handleSoldStatus({
                  campaignStatuses, setEntityState, sold, campaign_status_id: e.target.value,
                })}
                value={campaign_status_id}
              >
                {filteredCampaignStatuses.map(status => (
                  <option key={status.id} value={status.id}>{status.title}</option>
                ))}
              </select>
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Under Offer" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select name="under_offer" value={under_offer} data-value-type="boolean" {...handlers}>
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
            </Form.Field>
          </Form.Row>

          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Start Date" marginTop={['large', 0]}>
              <input
                name="start_date"
                type="date"
                value={start_date}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="End Date" marginTop={['large', 0]}>
              <input
                data-validate-field-on="change"
                name="end_date"
                min={start_date}
                type="date"
                value={end_date}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>
        </Form.Row>

        {!!sold && (
          <Form.Row marginTop="large">
            <Form.Row>
              <Form.Field label="Sold Price">
                <input name="sold_price" type="number" value={sold_price} {...handlers} />
              </Form.Field>

              {/*
               // @ts-expect-error TS2322 */}
              <Form.Field label="Sold Date" marginTop={['large', 0]}>
                <input name="sold_date" type="date" value={sold_date} {...handlers} />
              </Form.Field>
            </Form.Row>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Hide Sold Price" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select data-value-type="boolean" name="hide_sold_price" value={hide_sold_price} {...handlers}>
                <option value="false">No</option>
                <option value="true">Yes</option>
              </select>
            </Form.Field>
          </Form.Row>
        )}
      </Form>
    </DashboardModule>
  )
}

export default CampaignStatus
